import { render } from "./BodyView.vue?vue&type=template&id=28e963db&scoped=true&lang=pug"
import script from "./BodyView.vue?vue&type=script&setup=true&lang=js"
export * from "./BodyView.vue?vue&type=script&setup=true&lang=js"

import "./BodyView.vue?vue&type=style&index=0&id=28e963db&lang=sass&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28e963db"]])

export default __exports__